import React from 'react'

const Footer = () => {
  return (
    <>
      <div className="inner">
        <div className="copy">
          <p>
            &copy; {new Date().getFullYear()} by{' '}
            <a
              href="https://www.linkedin.com/in/abu-musa-ahmed-abir-524897138/"
              target="_blank"
              rel="noreferrer"
            >
              Ahmmed Abir
            </a>
            . All rights reserved.
          </p>
        </div>
      </div>
    </>
  )
}

export default Footer
